import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  ViewChild,
  ElementRef, Inject, HostListener
} from '@angular/core';
import { get, isEmpty, findIndex, remove, cloneDeep, includes, find , has, uniqBy } from 'lodash';
import { Observable } from 'rxjs';
import { ICloseReturnType, PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { FileService } from '@ispm-client/modules/file-module/services/file.service';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { EventService } from '@ispm-client/modules/events/services/event.service';
import { ConfirmModalLoaderPayload } from '@ispm/layout/classes/confirm-modal-loader-payload';
import { ModalLoaderNgjsService } from '@ispm/layout/services/modal-loader-ngjs.service';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import { MultiFileParsingService } from '@ispm-client/modules/file-module/services/multi-file-parsing.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
  selector: 'ispm-gallery-viewer',
  templateUrl: './gallery-viewer.component.html',
  styleUrls: ['./gallery-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('Gallery')
export class GalleryViewerComponent extends PlaceholderChildComponent implements OnInit, IWidgetItem {
  wrapperClass: string = '';
  // prettyImageList: any = [];
  _thumbnailCollections: any; // in case we have thumbnails received
  _selectedThumbnail: any;
  isImageHidden: boolean = false;
  isFirst: boolean = true;
  isLast: boolean = false;
  data: any;
  payload: any;
  selectedFileContent: Observable<any>;
  downloading: boolean = true;
  showFullView: boolean = false;
  navigateThumbnailCount = 5;
  @ViewChild('loading', {static: false}) loading;
  @Input() showNavigationIcons: boolean = true;
  @Input() thumbnailConfiguration: any;
  @Input() selectedEvent: any;
  @Input() galleryType: String = 'image';




  constructor(
    private _fileService: FileService,
    private _eventService: EventService,
    private _modalLoaderService: ModalLoaderNgjsService,
    private _changeDetector: ChangeDetectorRef,
    private notificationMessageService: NotificationMessageService,
    private notificationMessage: NOTIFICATION_MESSAGE,
    private _ispmHttpClient: IspmHttpClient,
    private _multiFileParsingService: MultiFileParsingService) {
    super();
  }

  set widgetData(widgetData: any) {
    this.data = widgetData;
  }

  /**
   * set event image gallery config
   * @param config
   */
  set widgetConfig(config: any) {
    this.payload = config.widgetPayload;
  }
  ngOnInit() {
    if (this.payload) {
      this.data = get(this.payload, 'data');
      this.selectedEvent = get(this.payload, 'selectedEvent');
      this.galleryType = get(this.payload, 'galleryType');
      this.thumbnailConfiguration = get(this.payload, 'thumbnailConfiguration');
      if (!isEmpty(this.data)) {
        this.thumbnailCollections = this.data;
      }
    }
    else {
      if (this.data) {
        this.thumbnailCollections = this.data;
      }
    }
    if (this._thumbnailCollections) {
      this._selectedThumbnail = this._thumbnailCollections[0];
      this.onThumbnailSelected(this._selectedThumbnail, true, this._thumbnailCollections.length == 1 ? true : false, false);
    }

    this.navigateThumbnailCount = get(this.thumbnailConfiguration, 'thumbnailShowCount', '');
  }

  @Input() set thumbnailCollections(_images: any) {
    if (!isEmpty(_images)) {
      this._thumbnailCollections = cloneDeep(_images);
      if (isEmpty(this._selectedThumbnail)) {
        this._selectedThumbnail = this._thumbnailCollections[0];
      }
      this._changeDetector.markForCheck();
    }
  }
  onThumbnailSelected(file, isFirst, isLast, scrollIntoView= true) {
    this._selectedThumbnail = file;
    this.isImageHidden = true;
    const self = this;
    setTimeout(() => {
      self.isImageHidden = false;
      // self._changeDetector.markForCheck();
    }, 0);
    this.isFirst = isFirst;
    this.isLast = isLast;
    if (has(file, 'id')) {
      this.selectedFileContent = this._eventService.getFileFromCache(file.id);
    } else if (get(file, 'resourceType' , ' ') === 'DICOM' && has(file, 'reference')){
      let patientId: String = null;
      let studyId: String = null;
      const context: any = get(this.selectedEvent, 'context');
      context.forEach(contxt => {
        if(contxt.resourceType === 'Patient') {
          patientId = contxt.reference;
        }
        if(contxt.resourceType === 'StudyInstanceUid') {
          studyId = contxt.reference;
        }
      });
      this.selectedFileContent = this._multiFileParsingService.getFileFromWADOUrl(file, studyId, patientId);
    }
    if (scrollIntoView) {
      document.getElementById(`ispm-auto-image-thumbnail-${file.id}`).scrollIntoView({ behavior: 'smooth', block: 'start' , inline: 'start'});
    }
    this.downloading = false;
    /*if(this.selectedFileContent){
      this.downloading = false;
    }*/
  }
  beforeClose(_modalResponse?: modalResponse): void | ICloseReturnType {
    return undefined;
  }
  onNavigate(direction) {
    const noOfImages = this._thumbnailCollections.length;
    let currentIndex =0;
    if(this._thumbnailCollections[0].isExternal) {
      this._thumbnailCollections = uniqBy(this._thumbnailCollections,'reference');
      currentIndex = findIndex(this._thumbnailCollections, item => item['reference'] == this._selectedThumbnail['reference']);
    }
    else
    currentIndex=findIndex(this._thumbnailCollections, item => item['id'] == this._selectedThumbnail['id']);
    if (direction == 'previous') {
      currentIndex = currentIndex===0?0:currentIndex - 1;
    } else {
      currentIndex = currentIndex===noOfImages-1?noOfImages-1:currentIndex + 1;
    }
    this.onThumbnailSelected(this._thumbnailCollections[currentIndex], currentIndex === 0, currentIndex === (noOfImages - 1), false);
  }

  navigateThumbnail(direction) {
    const noOfImages = this._thumbnailCollections.length;
    let currentIndex = findIndex(this._thumbnailCollections, item => item['id'] == this._selectedThumbnail['id']);
    if (direction == 'previous') {
      currentIndex = (currentIndex - this.navigateThumbnailCount) <= 0 ? 0 : (currentIndex - this.navigateThumbnailCount);
    } else {
      if (currentIndex === 0) {
        currentIndex += this.navigateThumbnailCount - 1 <= (noOfImages - 1) ? this.navigateThumbnailCount - 1 : noOfImages - currentIndex - 1;
      }
      else {
        currentIndex = (currentIndex + this.navigateThumbnailCount) <= (noOfImages - 1) ? currentIndex + this.navigateThumbnailCount : noOfImages - 1;
      }
    }
    this.onThumbnailSelected(this._thumbnailCollections[currentIndex], currentIndex === 0, currentIndex === (noOfImages - 1));
  }

  toggleFullView(e) {
    e.preventDefault();
    this.showFullView = !this.showFullView;
  }
  onScroll(event, scrollType) {
    event.preventDefault();
    if (scrollType.toLowerCase(  ) === 'vertical') {
      const scrollTop = event.target.scrollTop;
      const scrollHeight = event.target.scrollHeight;
      const offsetHeight = event.target.offsetHeight;
      const scrollHeightPosition = scrollTop + offsetHeight;
      const eachContentHeight = scrollHeight / this._thumbnailCollections.length;
      const positionY = Math.floor(scrollHeightPosition / eachContentHeight) >= this._thumbnailCollections.length - 1 ? this._thumbnailCollections.length - 1 : Math.floor(scrollHeightPosition / eachContentHeight);
      this.onThumbnailSelected(this._thumbnailCollections[positionY], positionY === 0, positionY === this._thumbnailCollections.length - 1, false);
    }
    else {
      const scrollLeft = event.target.scrollLeft;
      const scrollWidth = event.target.scrollWidth;
      const offsetWidth = event.target.offsetWidth;
      const scrollWidthtPosition = scrollLeft + offsetWidth;
      const eachContentWidth = scrollWidth / this._thumbnailCollections.length;
      const positionX = Math.floor(scrollWidthtPosition / eachContentWidth) >= this._thumbnailCollections.length - 1 ? this._thumbnailCollections.length - 1 : Math.floor(scrollWidthtPosition / eachContentWidth);
      this.onThumbnailSelected(this._thumbnailCollections[positionX], positionX === 0, positionX === this._thumbnailCollections.length - 1, false);

    }
  }

  deleteReport(file) {
    this._modalLoaderService.popupModal('confirm',
      ConfirmModalLoaderPayload.builder()
        .setTitle('Delete File')
        .setContent(`Are you sure want to delete ${file.friendlyName} file?`)
        .setApproveButtonText('Confirm')
        .setDeclineButtonText('Cancel'),
      'ALERT'
    ).subscribe((response: modalResponse) => {
      if (get(response, 'payload') === modalResponse.approve) {
        const content: any = get(this.selectedEvent, 'content');
        remove(content, item => {
          return get(item, 'reference') === get(file, 'id');
        });
        this._eventService.updateEvent(this.selectedEvent.id, this.selectedEvent).subscribe(data => {
          this.notificationMessageService.success(this.notificationMessage.FILE_DELETED_SUCCESSFULLY);
          this.selectedEvent = data;
          const  queries = [];
          this.selectedEvent.content.forEach(file => {
            if (file.contentType.toLowerCase() === 'file') {
              queries.push({
                'targetResource': get(file, 'resourceType'),
                'queryString': `_id=${get(file, 'reference')}`
              });
            }
          });

          this.refreshData(queries);
        });
      }
    });
  }

  refreshData(queries) {
    this._thumbnailCollections = [];
    this._ispmHttpClient.get('hsdpauth/getAccessToken').subscribe((value:any) => {

    })
    this._ispmHttpClient.post('bundleUtil/search', { queries}).subscribe(val => {
      const fileList = [];
      if (val && val.length > 0) {
        val.forEach((fileMeta, index) => {
          const fileData = get(fileMeta, 'response.entry[0].resource');
          if (this.galleryType === 'image' && includes(['gif', 'png', 'jpeg', 'tiff', 'jpg'], fileData.fileType.toLowerCase())) {
            if (!find(this._thumbnailCollections, (obj) => obj.id === fileData.id)) {
              this._thumbnailCollections.push({ ...fileData});
            }
          } else if (this.galleryType === 'video' && includes(['mp4', 'mov', 'avi', 'flv'], fileData.fileType.toLowerCase())) {
            if (find(this._thumbnailCollections, (obj) => obj.id === fileData.id)) {
              this._thumbnailCollections.push({ ...fileData});
            }
          }
        });
        this._thumbnailCollections.length > 0 ? this.onThumbnailSelected(this._thumbnailCollections[0], true, this._thumbnailCollections.length - 1 === 0) : this.selectedFileContent = null;
      }
      else {
        this._thumbnailCollections = [];
      }
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    });
  }

  @HostListener('mousewheel', ['$event']) onMousewheel(event) {
    if(event.wheelDelta>0){
      this.onNavigate('next')
    }
    if(event.wheelDelta<0){
      this.onNavigate('previous')
    }
  }
}
